<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">Phân Quyền</h3>
      </div>
      <div class="box-body">
        <div
          style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
        >
          <div
            class="box custom-box"
            style="margin-top:40px;border:1px solid white;width:100vw;display:table-cell;"
          >
            <div class="welcome" style="border: 0px solid black;width:100vw;display:table-cell;">
              <row style="border:1px solid white;display:table-cell;width:100vw">
                <div
                  style="border:0px solid red;text-align:center;
                  font-size: 12px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
                >
                  <div
                    style="background:#fafafa;float:left;border: 1px solid rgb(244, 244, 244);width:150px;;margin-left:5px;margin-top:1%;"
                  >
                    <div
                      v-for="(item, index) in serviceData" :key="index"
                      style="display:flow-root;text-align:center;border:0px solid red;"
                    >
                      <button
                        class="btn btn-sq-sm btn-primary"
                        style="margin-bottom:5%;margin-top:5%;width:90%;font-size: 10px;"
                        @click="setActivate(index, item)"
                      >
                        <i class="fa fa-plug fa-2x"></i>
                        <br>
                        {{item.key}}
                      </button>
                    </div>
                  </div>
                  <!-- Left -->
                  <div style="width:calc(100% - 160px);border:0px solid red;float:right;">
                    <!-- Right -->
                    <div v-if="isShowRightContent" class="right_banner">
                      <lte-table-checkbox
                        :hdBackground="hdBackground"
                        :data="dataOfTable"
                        :namePrivilege="namePrivilege"
                        :columns="gridColumns"
                        :useCheckBox="true"
                        @selectedItems="selectedCheckBox"
                      />
                    </div>
                    <!-- Right -->
                  </div>
                </div>
              </row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import moment from "moment";
// import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTETableCheckBox from "@/components/LTETableCheckBox.vue";
// import utils from '@/lib/utils'

export default {
  name: "DecentralizationUser",
  data() {
    return {
      gridColumns: [
        "Chức Năng",
        "Hiệu Chỉnh",
        "Chỉ Đọc",
        "Tạo Mới",
        "Xóa",
        "In",
        "Advance"
      ],
      hdBackground: "background-color: #4b646f;color:white;border:1px solid white;",
      serviceData: [
        {
          key: "Quản Lý Căn Hộ",
          alsa: "QLCH",
          value: [
            {
              "Chức Năng": "a",
              "Hiệu Chỉnh": "",
              "Chỉ Đọc": "",
              "Tạo Mới": "",
              "Xóa": "",
              "In": "",
              "Advance": "",
            },
            {
              "Chức Năng": "b",
              "Hiệu Chỉnh": "",
              "Chỉ Đọc": "",
              "Tạo Mới": "",
              "Xóa": "",
              "In": "",
              "Advance": "",
            },
          ],
          isCollapsed: true
        },{
          key: "Quản Lý Tài Sản",
          alsa: "QLTS",
          value: [
            {
              "Chức Năng": "c",
              "Hiệu Chỉnh": "",
              "Chỉ Đọc": "",
              "Tạo Mới": "",
              "Xóa": "",
              "In": "",
              "Advance": "",
            },
            {
              "Chức Năng": "d",
              "Hiệu Chỉnh": "",
              "Chỉ Đọc": "",
              "Tạo Mới": "",
              "Xóa": "",
              "In": "",
              "Advance": "",
            },
          ],
          isCollapsed: true
        },{
          key: "Quản Lý Phản Hồi",
          alsa: "QLPH",
          value: [
            {
              "Chức Năng": "e",
              "Hiệu Chỉnh": "",
              "Chỉ Đọc": "",
              "Tạo Mới": "",
              "Xóa": "",
              "In": "",
              "Advance": "",
            },
            {
              "Chức Năng": "f",
              "Hiệu Chỉnh": "",
              "Chỉ Đọc": "",
              "Tạo Mới": "",
              "Xóa": "",
              "In": "",
              "Advance": "",
            },
            {
              "Chức Năng": "f",
              "Hiệu Chỉnh": "",
              "Chỉ Đọc": "",
              "Tạo Mới": "",
              "Xóa": "",
              "In": "",
              "Advance": "",
            },
          ],
          isCollapsed: true
        }
      ],
      dataOfTable: [],
      isShowRightContent: false,
    };
  },
  watch: {
    GET_SERVICE_DATA: function() {
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_SERVICE_DATA",
      "PAGINATION",
      "GET_SNACK_BAR",
      "SERVICE_TYPE_LIST"
    ])
  },
  created() {
  },
  methods: {
    ...mapActions([
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_SERVICE_LIST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_SERVICE_TYPE_LIST"
    ]),
    selectedCheckBox: function(e) {
    },
    toggleButton: function(service) {
      service.isCollapsed = !service.isCollapsed;
    },
    toggleButtonSub: function(serviceSub) {
      serviceSub.isCollapsedSub = !serviceSub.isCollapsedSub;
    },
    addService: function() {
    },
    setEvent: function(index) {
      this.activeEvent = index;
    },
    setActivate: function(index, item) {
      this.isShowRightContent = true
      this.dataOfTable = item.value
      this.namePrivilege = item.alsa
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_SERVICE_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },

    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_SERVICE_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },

    onPagination: function(value) {
      if (value === 0) return false;
      const data = {
        params: {
          page: value
        }
      };
      this.GET_SERVICE_LIST(data);
      this.GET_SERVICE_TYPE_LIST();
    }
  },

  mounted() {
  },
  components: {
    // "lte-core-alert": LTECoreAlert,
    "lte-table-checkbox": LTETableCheckBox
  }
};
</script>

<style lang="scss" scoped>
.icon-center {
  margin-top: 4px;
  margin-left: -5px;
}
.red-featured-box .box-content {
  border-top-color: #e6272e;
}
.featured-box {
  width: 89%;
}
.featured-box:hover .box-content {
  background-position: center 1.3em;
}
.featured-box .box-content {
  padding: 17px 16px 10px;
  min-height: 415px;
}
.featured-box .box-content {
  border-radius: 8px;
  border-top: 3px solid #33b8ff;
}
.featured-box {
  background: linear-gradient(
    to bottom,
    #fefefe 0%,
    #fdfdfd 27%,
    #fbfbfb 50%,
    #f8f8f8 76%,
    #f6f6f6 100%
  );
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid #dfdfdf;
  border-left: 1px solid #ececec;
  border-radius: 8px;
  border-right: 1px solid #ececec;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  min-height: 100px;
  position: relative;
  text-align: center;
  z-index: 1;
  width: 89%;
}

/*
    @hiercelik - hiercelik.net
    @koalapix - koalapix.com
*/

.kpx_login .kpx_authTitle {
  text-align: center;
  line-height: 200%;
}

.kpx_login .kpx_socialButtons a {
  color: white; // In yourUse @body-bg
  opacity: 0.9;
}
.kpx_login .kpx_socialButtons a:hover {
  color: white;
  opacity: 1;
}

.kpx_login .kpx_socialButtons .kpx_btn-facebook {
  background: #3b5998;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  border-radius: 50%;
  height: 40px;
  width: 40px;
}
.kpx_login .kpx_socialButtons .kpx_btn-facebook:hover {
  background: #172d5e;
}
// .kpx_login .kpx_socialButtons .kpx_btn-facebook:focus {
//   background: #fff;
//   color: #3b5998;
//   border-color: #3b5998;
// }

.kpx_login .kpx_socialButtons .kpx_btn-twitter {
  background: #00aced;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  border-radius: 50%;
  height: 40px;
  width: 40px;
}
.kpx_login .kpx_socialButtons .kpx_btn-twitter:hover {
  background: #043d52;
}
.kpx_login .kpx_socialButtons .kpx_btn-twitter:focus {
  background: #fff;
  color: #00aced;
  border-color: #00aced;
}

.kpx_login .kpx_socialButtons .kpx_btn-google-plus {
  background: #c32f10;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  border-radius: 50%;
  height: 60px;
  width: 60px;
}
.kpx_login .kpx_socialButtons .kpx_btn-google-plus:hover {
  background: #6b1301;
}
.kpx_login .kpx_socialButtons .kpx_btn-google-plus:focus {
  background: #fff;
  color: #c32f10;
  border-color: #c32f10;
}

.kpx_login .kpx_socialButtons .kpx_btn-soundcloud {
  background: #ff8800;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  border-radius: 50%;
  height: 55px;
  width: 55px;
}
.kpx_login .kpx_socialButtons .kpx_btn-soundcloud:hover {
  background: #c73e04;
}
.kpx_login .kpx_socialButtons .kpx_btn-soundcloud:focus {
  background: #fff;
  color: #ff8800;
  border-color: #ff8800;
}

.kpx_login .kpx_socialButtons .kpx_btn-github {
  background: #666666;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-github:hover {
  background: #333333;
}
.kpx_login .kpx_socialButtons .kpx_btn-github:focus {
  background: #fff;
  color: #666666;
  border-color: #666666;
}

.kpx_login .kpx_socialButtons .kpx_btn-steam {
  background: #878787;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-steam:hover {
  background: #292929;
}
.kpx_login .kpx_socialButtons .kpx_btn-steam:focus {
  background: #fff;
  color: #878787;
  border-color: #878787;
}

.kpx_login .kpx_socialButtons .kpx_btn-pinterest {
  background: #cc2127;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-pinterest:hover {
  background: #780004;
}
.kpx_login .kpx_socialButtons .kpx_btn-pinterest:focus {
  background: #fff;
  color: #cc2127;
  border-color: #cc2127;
}

.kpx_login .kpx_socialButtons .kpx_btn-vimeo {
  background: #1ab7ea;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-vimeo:hover {
  background: #162221;
}
.kpx_login .kpx_socialButtons .kpx_btn-vimeo:focus {
  background: #fff;
  color: #1ab7ea;
  border-color: #1ab7ea;
}

.kpx_login .kpx_socialButtons .kpx_btn-lastfm {
  background: #c3000d;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-lastfm:hover {
  background: #5e0208;
}
.kpx_login .kpx_socialButtons .kpx_btn-lastfm:focus {
  background: #fff;
  color: #c3000d;
  border-color: #c3000d;
}

.kpx_login .kpx_socialButtons .kpx_btn-yahoo {
  background: #400191;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-yahoo:hover {
  background: #230052;
}
.kpx_login .kpx_socialButtons .kpx_btn-yahoo:focus {
  background: #fff;
  color: #400191;
  border-color: #400191;
}

.kpx_login .kpx_socialButtons .kpx_btn-vk {
  background: #45668e;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-vk:hover {
  background: #1a3352;
}
.kpx_login .kpx_socialButtons .kpx_btn-vk:focus {
  background: #fff;
  color: #45668e;
  border-color: #45668e;
}

.kpx_login .kpx_socialButtons .kpx_btn-spotify {
  background: #7ab800;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-spotify:hover {
  background: #3a5700;
}
.kpx_login .kpx_socialButtons .kpx_btn-spotify:focus {
  background: #fff;
  color: #7ab800;
  border-color: #7ab800;
}

.kpx_login .kpx_socialButtons .kpx_btn-linkedin {
  background: #0976b4;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-linkedin:hover {
  background: #004269;
}
.kpx_login .kpx_socialButtons .kpx_btn-linkedin:focus {
  background: #fff;
  color: #0976b4;
  border-color: #0976b4;
}

.kpx_login .kpx_socialButtons .kpx_btn-stumbleupon {
  background: #eb4924;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-stumbleupon:hover {
  background: #943019;
}
.kpx_login .kpx_socialButtons .kpx_btn-stumbleupon:focus {
  background: #fff;
  color: #eb4924;
  border-color: #eb4924;
}

.kpx_login .kpx_socialButtons .kpx_btn-tumblr {
  background: #35465c;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.kpx_login .kpx_socialButtons .kpx_btn-tumblr:hover {
  background: #142030;
}
.kpx_login .kpx_socialButtons .kpx_btn-tumblr:focus {
  background: #fff;
  color: #35465c;
  border-color: #35465c;
}

.kpx_login .kpx_loginOr {
  position: relative;
  font-size: 1.5em;
  color: #aaa;
  margin-top: 1em;
  margin-bottom: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.kpx_login .kpx_loginOr .kpx_hrOr {
  background-color: #cdcdcd;
  height: 1px;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.kpx_login .kpx_loginOr .kpx_spanOr {
  display: block;
  position: absolute;
  left: 50%;
  top: -0.6em;
  margin-left: -1.5em;
  background-color: white;
  width: 3em;
  text-align: center;
}

.kpx_login .kpx_loginForm .input-group.i {
  width: 2em;
}
.kpx_login .kpx_loginForm .help-block {
  color: red;
}

@media (min-width: 768px) {
  .kpx_login .kpx_forgotPwd {
    text-align: right;
    margin-top: 10px;
  }
}
.active {
  background: powderblue;
}
.kpx_login .kpx_socialButtons .focus {
  background: #fff;
  color: #3b5998;
  border-color: #3b5998;
}
.right_banner {
  // background: aliceblue;
  background: #fafafa;
  margin-left: 5px;
  margin-top: 1%;
  float: left;
  height: 70px;
  border: 1px solid rgb(244, 244, 244);
  width: calc(100% - 115px);
  margin-right: 5px;
  border-radius: 4px;
  width: 99%;
  color: navy;
}
</style>



// WEBPACK FOOTER //
// src/views/Decentralization/DecentralizationUser.vue